import { getSDK } from '../sdk.js'

// Toggle a reaction emoji on a chat message.
// reactions column is JSONB: { "👍": ["email1", "email2"], "❤️": ["email3"] }
export const toggleReaction = async function (msgId, emoji) {
  const root = this?.state?.root
  if (!root || !msgId || !emoji) return

  const me = root.currentUserEmail
  if (!me) return

  // Optimistic update — toggle in local state immediately.
  const channelId = root.activeChannelId
  const map = { ...(root.messagesByChannel || {}) }
  const msgs = (map[channelId] || []).map(m => {
    if (m.id !== msgId) return m
    const reactions = { ...(m.reactions || {}) }
    const list = reactions[emoji] ? [...reactions[emoji]] : []
    const idx = list.indexOf(me)
    if (idx === -1) list.push(me)
    else list.splice(idx, 1)
    if (list.length) reactions[emoji] = list
    else delete reactions[emoji]
    return { ...m, reactions }
  })
  map[channelId] = msgs
  root.update({ messagesByChannel: map })

  // Persist via the SDK — the server-side `react` op handles the
  // read-modify-write atomically, no client-side race window.
  try {
    // migrated 2026-04-27 to SDK route workspaceProject.chat.messages react
    await getSDK().execute('workspaceProject.chat.messages', 'react', {
      id: msgId,
      emoji,
      userId: me
    })
  } catch (err) {
    console.error('[toggleReaction]', err)
  }
}
